const postUser = async (eId, pageName, date) => {
    // Only proceed if API_URL is available
    if (!process.env.API_URL) {
        console.warn('API_URL is not defined, skipping postUser call');
        return;
    }

    try {
      // Create abort controller for timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

      const response = await fetch(`${process.env.API_URL}/data/?e_id=${eId}&page=${pageName}&datetime=${date}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (response.ok) {
        // console.log('Data posted successfully');
        // Handle success, e.g., show a success message to the user
        // console.log(response)
      } else {
        console.error('Failed to post data:', response.status);
        // Handle failure, e.g., show an error message to the user
      }
    } catch (error) {
      // Only log errors that aren't abort errors (which are expected for timeouts)
      if (error.name !== 'AbortError') {
        console.error('Error posting data:', error);
      }
      // Handle unexpected errors silently to prevent page crashes
    }
  };

  export default postUser;